// Module
var code = "<div class=\"js-sortable\"> <span style=\"padding-right:10px\">{{ label }}</span> <span class=\"iconset iconset-{{ srcfield }}\"> <div class=\"icon fa fa-angle-down\"></div> <div class=\"icon fa fa-angle-up\"></div> </span> <span class=\"icon fa fa-ellipsis-v column-grabber\"></span> </div>";
// Exports
export default code;